import React from 'react';
import { displayPrice } from '../../../../../apps/checkout/src/client/lib/price';
import style from './index.module.scss';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

const ProductPrice = _ref => {
  let {
    price,
    discountedPrice,
    forPostPurchasePage
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: style.priceWrapper,
    "data-id": "product-price_index_ProductPrice_div",
    children: [/*#__PURE__*/_jsxs("div", {
      className: discountedPrice && !forPostPurchasePage ? style.discountedPrice : style.price,
      "data-id": "product-price_index_ProductPrice_div_div_1",
      children: [displayPrice(discountedPrice !== null && discountedPrice !== void 0 ? discountedPrice : price), " each"]
    }), discountedPrice && /*#__PURE__*/_jsx("div", {
      className: style.originalPrice,
      "data-id": "product-price_index_ProductPrice_div_2",
      children: "".concat(displayPrice(price), " each")
    })]
  });
};

export default ProductPrice;